import React,{useState, useEffect} from 'react';
import {Routes, Route, useNavigate, Link, useParams} from 'react-router-dom';
import moment from 'moment';
import {Table, Select, Spin, Input, Skeleton,Tooltip as AntTooltip } from 'antd';
import { ArrowRightOutlined,InfoCircleOutlined } from '@ant-design/icons';
import { postData, getData } from '../../config/api-connect';
import PercentageBadge from '../../components/percentageBadge'
import Spinner from '../../components/spinner'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar} from 'recharts';
import * as Styled from './style.js';

const { Option } = Select;
const { TextArea } = Input;

const RenewalAnalysis = () => {
  var local_city = JSON.parse(localStorage.getItem('cityId'))
  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }

  var local_game_type = JSON.parse(localStorage.getItem('gameType'))
  if(!local_game_type){
    local_game_type = 8
  }

	const [loading, setLoading] = useState(true)
	const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
	const [cityId, setCityId] = useState(local_city)
	const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
	const [venuelist, setVenuelist] = useState([])
  const [gameType, setGameType] = useState(local_game_type)
  const [renewalData,setRenewalData] = useState([])

  useEffect(() => {
    localStorage.setItem('selectedVenueId',JSON.stringify(selectedVenueId))
    localStorage.setItem('cityId',JSON.stringify(cityId))
    localStorage.setItem('gameType',JSON.stringify(gameType))
    if(cityId && selectedVenueId && gameType) {
			getRenewalAnalysis()
		}
  }, [selectedVenueId,cityId,gameType]);

	useEffect(() => {
		getVenues()
	}, []);

	useEffect(() => {
		if(cities.length){
			getVenuesInCity()
		}
	}, [cities,cityId]);

	const handleCityChange = (value) => {
		if (value.length > 0) {
		  const last_selected = value[value.length - 1]
		  if(last_selected == 'All'){
		    setCityId(['All']);
		  }
		  else{
		    const filtered = value.filter(v => v !== 'All');
		    setCityId(filtered)
		  }
		}
		else {
		  setCityId(['All']);
		}
	};

	const getVenuesInCity =() =>{
		if(cities[0] && !cityId){
		  setCityId([cities[0].id])
		}

		let filteredVenues;

		if (cityId === 'All' || (Array.isArray(cityId) && cityId.includes('All')) ) {
		  filteredVenues = venues;
		} else {
		  filteredVenues = Array.isArray(cityId) ? venues.filter(item => cityId.includes(item.city)) : venues ;
		}

		setVenuelist(filteredVenues);
		const venueExists = filteredVenues.some(item => item.id === selectedVenueId);
		if (!venueExists) {
		  setSelectedVenueId('All');
		}
	}

	const getVenues = async () => {
		await getData('/business/get_venues_for_buddies/')
		.then(response =>{
		  setVenues(response.result)
		  setCities(response.cities)
		})
		.catch(error => {
		  setLoading(false)
		  console.log(error.message);
		});
	}

	const getRenewalAnalysis = async () => {
		setLoading(true)
		await getData(`/business/get_renewal_analysis/?venue_id=${selectedVenueId}&city_id=${cityId}&game_type_id=${gameType}`)
		.then(response =>{
		  setRenewalData(response.results)
		})
		.catch(error => {
		  console.log(error.message);
		})
		.finally(()=> {
			setLoading(false)
		})
	}

  const description_list = [
    {
        "label": "Total",
        "description": "Total number of students whose subscriptions ended during the month. This includes both students who have already renewed and those pending renewal."
    },
    {
        "label": "Renewed",
        "description": "Out of the students whose subscriptions ended, this represents those who have renewed — either within the same month or in subsequent months."
    },
    {
        "label": "Pending / Dropped",
        "description": "Out of the students whose subscriptions ended, this represents those who have not renewed their memberships yet."
    }
  ]

  const getDescription = (label) => {
    const item = description_list.find(d => d.label === label);
    return item ? item.description : '';
  };

	const renderHeader = (label,hasInfo) => {
    return(
      <Styled.RenewalTableHeader hasInfo={hasInfo}>
      	{hasInfo && <span></span> }
	      <span>{label}</span>
	      {hasInfo && 
	      	<AntTooltip title={getDescription(label)}> 
	      		<InfoCircleOutlined style={{cursor:'pointer'}}/>
	      	</AntTooltip>
	      }
      </Styled.RenewalTableHeader>
    )
  } 

	const columns = [
    {
      title: renderHeader('Month',false),
      dataIndex: 'month',
      key: 'month',
		  align: 'center',
		  width:'20%',
  		render: (text) => <div>{moment(text, 'MMMM YYYY').format('MMM YYYY')}</div>
    },
    {
      title: renderHeader('Total',true),
      dataIndex: 'total',
      key: 'total',
		  align: 'center',
		  width:'20%',
		  render: (value,record) => {
		  	const monthYear = moment(record.month, 'MMMM YYYY').format('MM-YYYY');
        return(
          <Link to={`/renewal-analysis/expired/${monthYear}`} className='venueTitle'
                  style={{display:'flex',gap:'5px',alignItems:'center',justifyContent:'center'}}>
          	{value} <ArrowRightOutlined style={{fontSize: 'xx-small'}} />
          </Link>
          )
      }
    },
    {
      title: renderHeader('Renewed',true),
      dataIndex: 'renewals',
      key: 'renewals',
		  align: 'center',
		  width:'20%',
    },
    {
      title: renderHeader('Pending / Dropped',true),
      dataIndex: 'dropped',
      key: 'dropped',
      render: (value,record) => {
      	const mmmmYYYY = moment(record.month, 'MMMM YYYY');
	      const month = mmmmYYYY.format('MM');
	      const year = mmmmYYYY.format('YYYY');
	      const monthYear = month + '-' + year
        return(
          <Link to={`/renewal-analysis/dropped/${monthYear}`} className='venueTitle' 
                style={{display:'flex',gap:'5px',alignItems:'center',justifyContent:'center'}}>
          	{value} <ArrowRightOutlined style={{fontSize: 'xx-small'}} />
          </Link>
          )
      },
		  align: 'center',
		  width:'20%',
    },
    {
      title: renderHeader('Renewal (%)',false),
      dataIndex: 'renewal_percentage',
      key: 'renewal_percentage',
      render: (value) => {
        return(
          <PercentageBadge value={value} />
          )
      },
		  align: 'center',
		  width:'20%',
    },
  ]

  const formatXAxis = (value) => {
    return moment(value).format('MMM')
  };

	return (
    <Styled.MainContainer>
      <Styled.TopDiv>    
        <Styled.SelectorContainer>

          {cities.length > 1 &&         
            <Styled.Selector>
              <span className='indicatorText'>City</span>
              <Select
                mode="multiple"
                className = 'mainSelector'
                style={{width: 150}}
                showSearch = {true}
                placeholder="Search to Select"
                optionFilterProp="children"
                filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                onChange={handleCityChange}
                value = {cityId}
                bordered={false}
              >
                <Option value="All" name="All"> All </Option>
                {
                  cities.map(item=>(
                    <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                  ))
                }
              </Select>
            </Styled.Selector>
          }
          {venuelist && venuelist.length > 0 &&
	          <Styled.Selector>
	            <span className='indicatorText'>Venue</span>
	            <Select
	              className = 'mainSelector'
	              style={{width: 300}}
	              showSearch = {true}
	              placeholder="Search to Select"
	              optionFilterProp="children"
	              filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
	              onChange={setSelectedVenueId}
	              value = {selectedVenueId}
	              bordered={false}
	            >
	              <Option value="All" name="All"> All </Option>
	              {venuelist.map(item=>(
	                <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
	                ))
	              }
	            </Select>
	          </Styled.Selector>
          }

          <Styled.Selector>
            <span className='indicatorText'>Program</span>
            <Select
                className = 'mainSelector'
                style={{width: 210}}
                onChange={setGameType}
                value = {gameType}
                bordered={false}
              >
                <Option value="8"> Football Academy </Option>
                <Option value="10"> Badminton Academy </Option>
                <Option value="65"> Swimming Academy </Option>
                <Option value="44"> Tennis Academy </Option>
              </Select>
          </Styled.Selector>
        </Styled.SelectorContainer>
      </Styled.TopDiv>
      <Styled.Header>          
        <span> Renewal Analysis</span>
      </Styled.Header>
      <Styled.GraphContainer>

        <Styled.GraphDiv>
          <Styled.GraphDivLabelDiv>
            <Styled.LabelHeading> Renewal Percentage </Styled.LabelHeading>

            <Styled.GraphMonthSelector>
              Last 12 months
            </Styled.GraphMonthSelector>
          
          </Styled.GraphDivLabelDiv>

          {loading ?
            <div style={{ height: '28vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
              <Spin />
            </div>
          :
            <ResponsiveContainer width="100%" height="80%">
              <LineChart
                width={400}
                height={400}
                data={renewalData}
                margin={{top: 5,right: 10,left: 5,bottom: 5}}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                  dataKey="month"
                  tickFormatter={(value) => moment(value, "MMMM YYYY").format("MMM")}
                />
                <YAxis  domain={[0, 100]} />
                <Tooltip formatter={(value) => (value + ' %')}/>
                <Legend />
                <Line type="monotone" dataKey="renewal_percentage" stroke="#009688" name="Renewal" />
              </LineChart>
            </ResponsiveContainer>
          }

          <span></span>
        </Styled.GraphDiv>
        
        <span></span>
        
        <Styled.GraphDiv>
          <Styled.GraphDivLabelDiv>
            <Styled.LabelHeading> Dropped Customers </Styled.LabelHeading>
            <Styled.GraphMonthSelector>
	            Last 12 months
	          </Styled.GraphMonthSelector>
          </Styled.GraphDivLabelDiv>

	        {loading ?
	          <div style={{ height: '28vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
	            <Spin />
	          </div>
	        :
	          <ResponsiveContainer width="100%" height="80%">
	            <BarChart
	              width={400}
	              height={400}
	              data={renewalData}
	              margin={{top: 5,right: 10,left: 5,bottom: 5}}
	            >
	              <CartesianGrid strokeDasharray="3 3" />
	              <XAxis dataKey="month" tickFormatter={formatXAxis}/>
	              <YAxis />
	              <Tooltip />
	              <Legend />
	              <Bar type="monotone" dataKey="dropped" fill="#E57373" name="Dropped" />
	            </BarChart>
	          </ResponsiveContainer>
	        }
	        <span></span>
        </Styled.GraphDiv>

      </Styled.GraphContainer>
      {loading ?
        <Skeleton active paragraph={{ rows: 7 }} title={false} />
      :
	      <Table
					className="table_container"
					tableLayout="fixed"
					rowKey="id"
					columns={columns}
					dataSource={[...renewalData].reverse()}
					pagination={false}
          scroll={{ x: 'max-content' }}

				/>
			}
    </Styled.MainContainer>
  );
}

export default RenewalAnalysis